import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/expense/submitExpense'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v3_edit_expense_entry } from '../../actions/v3/expenses'
import { v2_get_expense_types, v2_siteLocations } from '../../actions/v2/masterData'
import { decodeBase64JsonPayload } from '../../utils'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const parsedExpense = decodeBase64JsonPayload(data);
    const onSubmit = (model) => {
        model.append('expenseId', parsedExpense['ID'])
        model.append('previousExpenseFromDate', parsedExpense['EXPENSE_FROM_DATE'] || parsedExpense['EXPENSE_DATE'])
        model.append('previousExpenseToDate', parsedExpense['EXPENSE_TO_DATE'] || parsedExpense['EXPENSE_DATE'])
        v3_edit_expense_entry(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.expenseList.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    const [expenseTypes, setExpenseTypes] = useState([]);
    const [siteLocations, setSiteLocations] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchExpenseTypes = async () => {
        const res = await v2_get_expense_types();
        if (res.status) {
            setExpenseTypes(res.result || []);
        } else {
            toast.error('Failed to load expense types');
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchExpenseTypes();
        v2_siteLocations().then((res) => {
            if (res.status) {
                setSiteLocations(res.result || []);
            }
        });
    }, []);
    return (
        <React.Fragment>
            <Layout
                title={'Edit Expense'}>
                <Form
                    // title={'Edit Expense'}
                    onSubmit={onSubmit}
                    data={parsedExpense}
                    buttonName={'Save'}
                    expenseTypes={expenseTypes}
                    siteLocations={siteLocations}

                />
            </Layout>

        </React.Fragment>
    )
}

export default Add
